<template>
  <div id="app">
    <!-- <Header /> -->
    <!-- <Banner /> -->
    <div class='container'>
      <!-- <div class="col-md-6"> -->
      <router-view></router-view>
      <!-- </div > -->
      <!-- <Results v-if="result"/> -->
      <!-- <div class="col-md-6">
      </div > -->
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>

import Banner from './components/Banner.vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'

import Inputs from './components/Inputs.vue'
import Results from './components/Results.vue'

import { mapGetters } from 'vuex'
import annuities from './js/annuityCalc.js'

export default {
  name: 'app',
  components: {
    Inputs,
    Results,
    Banner,
    Footer,
    Header
  },
  computed: {
    ...mapGetters([
      'result',
      'selectedCurrentAge',
      'selectedAgePaymentsStart',
      'selectedCountry',
      'selectedGender'
    ])
  },
  mounted(){
    var vm = this;
    this.$getGapiClient()
      .then(gapi => {
        gapi.client.sheets.spreadsheets.values.get({
          spreadsheetId: '15gAZUb_QodglBcFgJAVNWoT0InRzTEOzuA8xCMPsBx8',
          range: 'Sheet3',
        }).then(function(response) {
          var values = response.result.values;
          values.shift()
          vm.$store.commit('setlifeExpData', values)
          gapi.client.sheets.spreadsheets.values.get({
            spreadsheetId: '15gAZUb_QodglBcFgJAVNWoT0InRzTEOzuA8xCMPsBx8',
            range: 'Sheet2',
          }).then(function(response) {
            var values = response.result.values;
            values.shift()
            vm.$store.commit('setGDPData', values)
            vm.defaultInputs()
          });
        });
      })
  },
  methods: {
    defaultInputs(){
      annuities.calc({ ctx: this })
    }
  }
}
</script>

<style>

p {
  line-height: 30px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>
